module.exports = __webpack_public_path__ + "fonts/baronsans-ultrahairlineitalic-webfont.bf35eb2b.woff2";